import React, { useRef, useState, useEffect } from "react"
import { RouteComponentProps } from "react-router-dom"
import { authAxios } from "../../../../API/apiRequest"
import MyPagination from "../../Components/Pagination/MyPagination"
import { IinterviewCardProps, InterviewCard } from "../../JobsManager/ApplicationCard/ApplicationCard"
import { ApplicantLoading, EmptyList, IApplicationsProps } from "../Applicants/Applicant"
import classes from '../EmployerJob.module.css'

const Interview: React.FC<IApplicationsProps & RouteComponentProps<{id: string}>> = (props)=>{
    const myRef = useRef<HTMLDivElement>(null)
    const [applications, setApplications] = useState<IinterviewCardProps[] | []>([])
    const [page, setPage] = useState(1)
    const [lastPage, setLastPage] = useState(1)
    const [loading, setLoading] = useState(true)

    useEffect(()=>{
        async function getApplications(){
            try{
                let result = await authAxios.get(`/employer/applications/accept?jobId=${props.match.params.id}`)
                setApplications(result.data.applications)
                setLastPage(result.data.lastPage)
                props.setTotal(result.data.total)

            }catch(e){
                console.log(e)
            }
            setLoading(false)
        }
        getApplications()

    },[props.match.params.id, props])
    
    const handlePageChange = async(event: React.ChangeEvent<unknown>, value: number)=>{
        if(myRef.current !== null)
            myRef.current.scrollIntoView({behavior: 'smooth'}) 
        setPage(value)
        setLoading(true)
        try{
            let result = await authAxios.get(`/employer/applications/accept?jobId=${props.match.params.id}&page=${value}`)
            setApplications(result.data.applications)
            setLastPage(result.data.lastPage)
            props.setTotal(result.data.total)

        }catch(e){
            console.log(e)
        }
        setLoading(false)
    }
    if(loading) return <ApplicantLoading />
    else{
    if(applications && applications.length === 0) return <EmptyList />
    else
    return(
        <React.Fragment>
        <div ref={myRef}>
            <p className={classes.jobText} style={{textAlign: 'center', fontWeight: 'bold'}}>
                {page} الصفحة
            </p>
        </div>
        {applications.map(a=><InterviewCard 
          name={a.name}
          id={a.id}
          date={a.date}
          phone={a.phone}
          key={a.id}
          picture={a.picture}
        />)}
        <MyPagination
            page={page}
            pages={lastPage}
            handlePageChange={handlePageChange}
        />
        </React.Fragment>
    )
    }
}

export default Interview